import {
  DEFAULT_ADD_COMMENT_LABEL,
  DEFAULT_TAB1_LABEL,
  DEFAULT_TAB2_LABEL,
  DEFAULT_TAB3_LABEL,
} from '../constants/labels'

export type TabKey = 'details' | 'comments' | 'history'

export type CaseTabsProps = {
  activeTab: TabKey
  onChange: (tab: TabKey) => void
  tab1Label?: string
  tab2Label?: string
  tab3Label?: string
  addCommentLabel?: string
  onAddComment?: () => void
}

export default function CaseTabs({
  activeTab,
  onChange,
  tab1Label = DEFAULT_TAB1_LABEL,
  tab2Label = DEFAULT_TAB2_LABEL,
  tab3Label = DEFAULT_TAB3_LABEL,
  addCommentLabel = DEFAULT_ADD_COMMENT_LABEL,
  onAddComment,
}: CaseTabsProps) {
  const TABS: { key: TabKey; label: string }[] = [
    { key: 'details', label: tab1Label },
    { key: 'comments', label: tab2Label },
    { key: 'history', label: tab3Label },
  ]

  return (
    <div className="cop-case-details__tabs-row">
      <div className="cop-case-details__tabs" role="tablist">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`cop-case-details__tab${activeTab === tab.key ? ' is-active' : ''}`}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <button type="button" className="cop-case-details__add-btn" onClick={onAddComment}>
        {addCommentLabel}
      </button>
    </div>
  )
}
